import Vue from 'vue';
import Vuex from 'vuex';

import section from './modules/section';
import employee from './modules/employee';
import attendance from './modules/attendance';
import filters from './modules/filters';
import positions from './modules/positions';
import record from './modules/record';
import trainings from './modules/trainings';
import penaltiesRewards from './modules/penalties-rewards';

import salaries from './modules/salaries/salaries';
import salaryEquations from './modules/salaries/salary-equations';
import deductions from './modules/salaries/deductions';
import recompenses from './modules/salaries/recompenses';
import levels from './modules/salaries/levels';
import slices from './modules/salaries/slices';
import reminders from './modules/reminders';
import remindersTypes from './modules/reminders-types';
import evaluations from './modules/evaluations';
import evaluationsTypes from './modules/evaluations-types';
import auth from './modules/auth';
import detailsTypes from './modules/detailsTypes'
import leaveOrPermission from './modules/leaveOrPermission'
import computerSkills from './modules/computerSkills'
import languages from './modules/languages'
import addTaskType from './modules/addTaskType'
import jobPlaces from './modules/jobPlaces'
import users from './modules/users'
import vacationOrPermissionType from './modules/vacationOrPermissionType'
import attendanceEmployee from './modules/attendanceEmployee'
import attendanceSystem from './modules/attendanceSystem'
import roles from './modules/roles'
import reports from './modules/reports'
import holiday from './modules/holiday'
import evaluation from './modules/evaluation'

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		auth,
		section,
		employee,
		attendance,
		filters,
		positions,
		record,
		trainings,
		penaltiesRewards,
		salaries,
		salaryEquations,
		deductions,
		recompenses,
		levels,
		slices,
		reminders,
		remindersTypes,
		evaluations,
		evaluationsTypes,
		detailsTypes,
		leaveOrPermission,
		computerSkills,
		languages,
		addTaskType,
		jobPlaces,
		users,
		vacationOrPermissionType,
		attendanceEmployee,
		attendanceSystem,
		roles,
		reports,
		holiday,
		evaluation
	},
});
